var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08335 13.1257V30.6256H1.41669V13.1257H7.08335ZM12.75 30.6256C11.9986 30.6256 11.2779 30.3184 10.7466 29.7714C10.2152 29.2244 9.91669 28.4825 9.91669 27.709V13.1257C9.91669 12.3236 10.2284 11.5944 10.7525 11.0694L20.0742 1.45898L21.5759 3.00482C21.9584 3.39857 22.1992 3.93815 22.1992 4.53607L22.1567 5.00273L20.8109 11.6673H29.75C31.3225 11.6673 32.5834 12.9798 32.5834 14.584V17.5007C32.5834 17.8798 32.5125 18.2298 32.385 18.5652L28.1067 28.8465C27.6817 29.8965 26.6759 30.6256 25.5 30.6256H12.75ZM12.75 27.709H25.5425L29.75 17.5007V14.584H17.2975L18.8984 6.82565L12.75 13.1694V27.709Z",
    fill: "#7A23FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpOutline);
export default __webpack_public_path__ + "static/media/thumb-up-outline.54022615d6bd815f58ce256b5b4e68ba.svg";
export { ForwardRef as ReactComponent };